import MarkdownDisplay from "./markdownDisplay.jsx";

/**
 * Textarea with an inline live markdown preview.
 *
 * @param {{
 *   id?: string,
 *   label?: string,
 *   value: string,
 *   onChange: React.ChangeEventHandler<HTMLTextAreaElement>,
 *   rows?: number,
 *   placeholder?: string,
 *   className?: string,
 * }} props
 */
export default function MarkdownEditor({
  id,
  label,
  value = "",
  onChange,
  rows = 4,
  placeholder,
  className = "",
}) {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-text-body mb-1">
          {label}
        </label>
      )}
      <textarea
        id={id}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full border border-border-default rounded py-2 px-3 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
      />
      <p className="text-sm font-medium text-text-body mt-3 mb-1">Förhandsgranskning</p>
      <div className="border border-border-default rounded p-4">
        <MarkdownDisplay data={value} />
      </div>
    </div>
  );
}
